import { AnalysisResultError } from '@/common/api/params/llmo'
import { CitationResult } from '@/common/model/media/citation'
import { MediaAnalysisProgress, MediaAnalysisStatus } from '@/common/model/media/mediaAnalysis'

export const CitationApiPath = {
  RUN_CITATION_ANALYSIS: '/api/sites/{site_id}/citation/run', // POST Run Citation Analysis（バックグラウンド実行）
  GET_CITATION_HISTORY_DETAIL: '/api/sites/{site_id}/citation/history/{history_id}' // GET Get Citation History Detail
}

export type CitationApiPath = (typeof CitationApiPath)[keyof typeof CitationApiPath]

export interface GetCitationHistoryDetailVars {
  site_id: number
  history_id: number
}

// バックグラウンド実行の入力。分析対象（media_analysis_target_id）から入力を解決する
export interface RunCitationAnalysisVars {
  site_id: number
  media_analysis_target_id?: number | null
  own_brand?: string
  own_url?: string
  competitor_brand?: string | null
  competitor_url?: string | null
}

export interface RunCitationAnalysisResponse {
  id: number
  analysis_type: string
  status: string // analyzing
}

export interface GetCitationHistoryDetailResponse {
  id: number
  input: Record<string, unknown>
  result: CitationResult & AnalysisResultError
  status?: MediaAnalysisStatus
  progress?: MediaAnalysisProgress
  created_at: string | null
}
